import Auth from "../Auth";

// Note: I end up importing this as CommentModel in a lot of places
// because of a name conflict with the Comment component
class Comment {
  static async getAll(documentId, options = {}) {
    const params = new URLSearchParams();
    if (options.includeResolved === true) {
      params.set("includeResolved", "true");
    }
    if (options.limit) {
      params.set("limit", String(options.limit));
    }
    if (options.cursor) {
      params.set("cursor", String(options.cursor));
    }
    if (options.type) {
      params.set("type", String(options.type));
    }
    const queryString = params.toString() ? `?${params.toString()}` : "";
    return Auth.fetchWithIdToken(`/api/comments/${documentId}/all${queryString}`,
      Array.isArray(options.annotationIds) ? { annotationIds: options.annotationIds } : undefined);
  }

  static async getCounts(documentId, options = {}) {
    return Auth.fetchWithIdToken(`/api/comments/${documentId}/all?countsOnly=true`,
      Array.isArray(options.annotationIds) ? { annotationIds: options.annotationIds } : undefined);
  }

  static async getById(commentId) {
    return Auth.fetchWithIdToken(`/api/comments/by-id/${commentId}`);
  }

  static async getByAnnotationId(annotationId) {
    return Auth.fetchWithIdToken(`/api/comments/by-annotation/${annotationId}`);
  }

  static async getByUser(documentId, userId) {
    return Auth.fetchWithIdToken(`/api/comments/${documentId}/user/${userId}`);
  }

  static async create({ documentId, content, annotationId, parentId, annotationSourceText, disableCommentThreadAgent = false, mode }) {
    return Auth.fetchWithIdToken(`/api/comments/new`, {
      documentId,
      content,
      annotationId,
      parentId,
      ...(annotationSourceText ? { annotationSourceText } : {}),
      disableCommentThreadAgent,
      ...(mode ? { mode } : {}),
    });
  }

  static async delete(commentId) {
    return Auth.fetchWithIdToken(`/api/comments/${commentId}`, {
      method: "DELETE",
    });
  }

  static async deleteAllByDocumentId(documentId) {
    return Auth.fetchWithIdToken(`/api/comments/document/${documentId}/all`, {
      method: "DELETE",
    });
  }

  static async resolve(annotationId, documentId) {
    return Auth.fetchWithIdToken(`/api/comments/${annotationId}/resolve`, {
      method: "POST",
      documentId,
    });
  }

  static async reopen(commentId) {
    return Auth.fetchWithIdToken(`/api/comments/${commentId}/reopen`, {
      method: "POST",
    });
  }

  static async update(commentId, content) {
    return Auth.fetchWithIdToken(`/api/comments/${commentId}/update`, {
      method: "POST",
      content,
    });
  }
}

export default Comment;
